import { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import PageHeader from "../components/layout/PageHeader";
import { Button } from "../components/ui/button";
import ConnectionCard from "../components/ConnectionCard";
import AddConnectionDialog from "../components/AddConnectionDialog";
import { api, apiErrorMessage } from "../lib/api";
import { toast } from "sonner";
import { TID } from "../lib/testIds";

export default function Connections() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    load();
  }, []);

  async function load() {
    setLoading(true);
    try {
      const { data } = await api.get("/connections");
      setList(data);
    } catch (e) {
      toast.error(apiErrorMessage(e));
    } finally {
      setLoading(false);
    }
  }

  function onCreated(conn) {
    setList((s) => [...s, conn]);
  }
  function onChange(updated) {
    setList((s) => s.map((c) => (c.id === updated.id ? updated : c)));
  }
  function onDeleted(id) {
    setList((s) => s.filter((c) => c.id !== id));
  }

  return (
    <div data-testid={TID.connections.root}>
      <PageHeader
        eyebrow="Servicios"
        title="Conexiones"
        description="Cada tarjeta representa un servicio web enlazado a KRAI CONNECT."
        actions={
          <Button
            data-testid={TID.connections.addButton}
            onClick={() => setDialogOpen(true)}
            className="bg-white text-black hover:bg-zinc-200 h-9"
          >
            <Plus className="h-4 w-4 mr-1.5" />
            Añadir conexión
          </Button>
        }
      />

      {loading ? (
        <div className="rounded-md border border-zinc-800 bg-zinc-950 p-10 text-sm text-zinc-500">
          Cargando conexiones…
        </div>
      ) : list.length === 0 ? (
        <div className="rounded-md border border-dashed border-zinc-800 bg-zinc-950 p-10 text-sm text-zinc-500">
          No hay conexiones aún. Crea la primera con el botón "Añadir conexión".
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {list.map((c) => (
            <ConnectionCard
              key={c.id}
              conn={c}
              onChange={onChange}
              onDeleted={onDeleted}
            />
          ))}
        </div>
      )}

      <AddConnectionDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        onCreated={onCreated}
      />
    </div>
  );
}
